/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FareType,
    FareTypeFromJSON,
    FareTypeFromJSONTyped,
    FareTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface FareTypeCriteriaInput
 */
export interface FareTypeCriteriaInput {
    /**
     * 
     * @type {boolean}
     * @memberof FareTypeCriteriaInput
     */
    exclude?: boolean;
    /**
     * 
     * @type {FareType}
     * @memberof FareTypeCriteriaInput
     */
    value?: FareType;
}

export function FareTypeCriteriaInputFromJSON(json: any): FareTypeCriteriaInput {
    return FareTypeCriteriaInputFromJSONTyped(json, false);
}

export function FareTypeCriteriaInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): FareTypeCriteriaInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'value': !exists(json, 'value') ? undefined : FareTypeFromJSON(json['value']),
    };
}

export function FareTypeCriteriaInputToJSON(value?: FareTypeCriteriaInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exclude': value.exclude,
        'value': FareTypeToJSON(value.value),
    };
}


